import { h } from 'preact';
import styles from './TextCheckboxList.module.scss';
export function TextCheckboxList({ options, onChange, layout }) {
    return (h("div", { class: layout === 'filterTop' ? styles.textCheckboxList : styles.textCheckboxListSide }, options.map(option => (h("label", { key: option.id, class: styles.radioLabel },
        h("input", { type: "checkbox", checked: option.selected, onChange: () => onChange(option.id) }),
        h("span", { class: styles.customRadio }),
        h("span", { class: styles.checkboxText }, option.label))))));
}
